import Grid from '@mui/material/Grid';

import BlogCard from '@/components/BlogComponents/shared/BlogCard/BlogCard';
import Heading from '@/components/Heading/Heading';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import type {
  BlogPageType,
  CuratedArticleGridType,
} from '@/contentful/api/api.types';
import useStyles from './BlogArticle2Up.styles';

export default function BlogArticle2Up({
  content,
}: {
  content: CuratedArticleGridType;
}): React.JSX.Element {
  const { articlesCollection, heading } = content;
  const { classes } = useStyles();

  return (
    <SpacingContainer isFeatured className={classes.spacingContainer}>
      <GridContainer fixed gridProps={{ className: classes.grid }}>
        {heading && (
          <Grid size={12}>
            <Heading level='h2' className={classes.articleHeading}>
              {heading}
            </Heading>
          </Grid>
        )}
        {articlesCollection?.items.map((article: BlogPageType, idx) => {
          const {
            blogTitle,
            heroImage,
            publicationDate,
            category,
            categoryPath,
            readTimeMinutes,
            path,
          } = article;

          return (
            <Grid
              key={`${blogTitle}-${publicationDate}`}
              size={{
                xs: 12,
                sm: idx <= 3 ? 6 : 4,
              }}
            >
              <BlogCard
                image={heroImage}
                title={blogTitle}
                url={path}
                readTime={readTimeMinutes}
                categoryPath={categoryPath}
                category={category}
              />
            </Grid>
          );
        })}
      </GridContainer>
    </SpacingContainer>
  );
}
